import { add, listen, qs, qsa, remove } from "@fluorescent/dom";
import loadYouTubeAPI from "@/lib/load-youtube-api";
import loadVimeoAPI from "@/lib/load-vimeo-api";

export default function media(node) {
  const externalVideos = qsa(".js-youtube, .js-vimeo");
  const externalVideoPlayers = [];
  const modelEls = qsa("model-viewer", node);

  if (externalVideos.length) {
    initExternalVideos(externalVideoPlayers);
  }

  if (modelEls.length) {
    initModels();
  }

  function initExternalVideos(externalVideoPlayers) {
    externalVideos.forEach(video => {
      const parent = video.closest(".media");
      const { host, videoId } = parent.dataset;

      switch (host) {
        case "youtube":
          loadYouTubeAPI().then(() => {
            const player = new window.YT.Player(video, {
              videoId,
              playerVars: {
                autohide: 0,
                cc_load_policy: 0,
                controls: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
                playlist: videoId,
              },
            });

            externalVideoPlayers.push(player);
          });

          break;
        case "vimeo":
          loadVimeoAPI().then(() => {
            const player = new window.Vimeo.Player(video, {
              id: videoId,
              controls: true,
              keyboard: false,
            });

            externalVideoPlayers.push(player);
          });

          break;
      }
    });
  }

  function initModels() {
    window.Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUI,
      },
    ]);

    initShopifyXr();
  }

  function setupModelViewerUI(errors) {
    if (errors) return;

    qsa("model-viewer", node).forEach(model => {
      initCustomModelButtons(model);
    });
  }

  function initCustomModelButtons(model) {
    const viewer = new window.Shopify.ModelViewerUI(model);

    const parentContainer = model.closest(".product__media");
    const poster = qs(".model-poster", parentContainer);
    const closeBtn = qs(".model-close", parentContainer);

    listen(poster, "click", () => {
      add(parentContainer, "model-active");
      viewer.play();
    });

    listen(closeBtn, "click", () => {
      remove(parentContainer, "model-active");
      viewer.pause();
    });
  }

  function initShopifyXr() {
    window.ProductModel = {
      loadShopifyXR() {
        window.Shopify.loadFeatures([
          {
            name: "shopify-xr",
            version: "1.0",
            onLoad: () => this.setupShopifyXR(),
          },
        ]);
      },
      setupShopifyXR: function setupShopifyXR(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
          listen(document, "shopify_xr_initialized", () => {
            setupShopifyXR();
          });
          return;
        }

        qsa('[id^="ModelJson-"]', document).forEach(modelJSON => {
          window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
          modelJSON.remove();
        });

        window.ShopifyXR.setupXRElements();
      },
    };

    listen(window, "DOMContentLoaded", () => {
      if (window.ProductModel) window.ProductModel.loadShopifyXR();
    });
  }

  function pauseAllMedia() {
    externalVideoPlayers.forEach(player => {
      // Youtube
      if (player.pauseVideo) {
        player.pauseVideo();
      }

      // Vimeo
      if (player.pause) {
        player.pause();
      }
    });

    qsa("video", node).forEach(video => video.pause());

    qsa("product-model", node).forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  return {
    pauseAllMedia,
  };
}
